















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card, Icon, Button, ButtonGroup } from '@alpha/ink'
import Redactor from '@/components/Redactor.vue'
import SaveRevertInput from '@/components/SaveRevertInput.vue'
import { TestStatus, TestPayload } from '@shared/types/database'

@Component({
  components: {
    SaveRevertInput,
    Card,
    Icon,
    Button,
    ButtonGroup,
    Redactor
  }
})
export default class TestObjectiveInput extends Vue {
  @Prop({ required: true }) objective!: string
  @Prop({ required: true }) decisionContext!: string
  @Prop({ required: true }) testTitle!: string
  @Prop({ required: true }) status!: TestStatus
  @Prop({ required: true }) updateTest!: (payload: Partial<TestPayload>) => Promise<void>

  showDecisionContext = false
  toggledDecisionContext = false
  editMode = {
    objective: false,
    decisionContext: false
  }

  saving = {
    objective: false,
    decisionContext: false
  }

  mounted () {
    this.showDecisionContext = this.decisionContext.length > 0
  }

  addDecisionContext () {
    this.showDecisionContext = true
    this.toggledDecisionContext = true
  }

  get draftMode () {
    return this.status === TestStatus.Draft
  }

  async saveObjectiveChanges (objective: string) {
    this.saving.objective = true
    await this.updateTest({ objective })
    this.editMode.objective = false
    this.saving.objective = false
  }

  async saveDecisionContextChanges (decisionContext: string) {
    this.saving.decisionContext = true
    if (decisionContext === '') {
      this.showDecisionContext = false
    }
    await this.updateTest({ decisionContext })
    this.editMode.decisionContext = false
    this.saving.decisionContext = false
  }
}
